module.exports = __webpack_public_path__ + "static/img/14000679.6749b44b.png";